"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("../../../packages/config");
var _safeConfig = require("../../../packages/config/safe-config");
var _index = require("../index.types");
const EOS_ENDPOINT_DICTIONARY = {
  GENERIC: "REACT_APP_EOS_ENDPOINT",
  VEHICLE_MANAGEMENT: "REACT_APP_EOS_V2_VEHICLE_MANAGEMENT_ENDPOINT",
  VEHICLE_HEALTH: "REACT_APP_EOS_V2_VEHICLE_HEALTH_ENDPOINT",
  VEHICLE_MAINTENANCE: "REACT_APP_EOS_V2_VEHICLE_MAINTENANCE_ENDPOINT",
  SERVICE_MANAGEMENT: "REACT_APP_EOS_V2_SERVICE_MANAGEMENT_ENDPOINT",
  VEHICLE_INFO: "REACT_APP_EOS_V2_VEHICLE_INFO_ENDPOINT",
  VEHICLE_SUBSCRIPTION: "REACT_APP_EOS_V2_VEHICLE_SUBSCRIPTION_ENDPOINT"
};
const useServiceInterceptor = function () {
  const config = (0, _config.useConfig)();
  return async function (internalConfig) {
    try {
      if (!(0, _index.isEOSRequestConfig)(internalConfig)) return internalConfig;
      if (!internalConfig.service) return internalConfig;
      internalConfig.baseURL = (0, _safeConfig.getSafeConfigValue)(config, EOS_ENDPOINT_DICTIONARY[internalConfig.service]);
      return internalConfig;
    } catch (err) {
      return Promise.reject(err);
    }
  };
};
var _default = exports.default = useServiceInterceptor;